import { library } from '@fortawesome/fontawesome-svg-core'
import { faStars } from '@fortawesome/pro-duotone-svg-icons/faStars'
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft'
import { faCamera } from '@fortawesome/pro-light-svg-icons/faCamera'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft'
import { faColumns } from '@fortawesome/pro-light-svg-icons/faColumns'
import { faFileImage } from '@fortawesome/pro-light-svg-icons/faFileImage'
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFolders } from '@fortawesome/pro-light-svg-icons/faFolders'
import { faFrown } from '@fortawesome/pro-light-svg-icons/faFrown'
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faHome } from '@fortawesome/pro-light-svg-icons/faHome'
import { faLockAlt } from '@fortawesome/pro-light-svg-icons/faLockAlt'
import { faMinusCircle } from '@fortawesome/pro-light-svg-icons/faMinusCircle'
import { faPhotoVideo } from '@fortawesome/pro-light-svg-icons/faPhotoVideo'
import { faSchool } from '@fortawesome/pro-light-svg-icons/faSchool'
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck'
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faUsersClass } from '@fortawesome/pro-light-svg-icons/faUsersClass'
import { faWrench } from '@fortawesome/pro-light-svg-icons/faWrench'
import { faFlag as falFlag } from '@fortawesome/pro-light-svg-icons/faFlag'
import { faHandsHeart as falHandsHeart } from '@fortawesome/pro-light-svg-icons/faHandsHeart'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle'
import { faCloud } from '@fortawesome/pro-regular-svg-icons/faCloud'
import { faCog } from '@fortawesome/pro-regular-svg-icons/faCog'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faEdit } from '@fortawesome/pro-regular-svg-icons/faEdit'
import { faEnvelopeOpen } from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpen'
import { faFlag } from '@fortawesome/pro-regular-svg-icons/faFlag'
import { faList } from '@fortawesome/pro-regular-svg-icons/faList'
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faShareAlt } from '@fortawesome/pro-regular-svg-icons/faShareAlt'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { faLockAlt as farLockAlt } from '@fortawesome/pro-regular-svg-icons/faLockAlt'
import { faUsersClass as farUsersClass } from '@fortawesome/pro-regular-svg-icons/faUsersClass'
import { faWrench as farWrench } from '@fortawesome/pro-regular-svg-icons/faWrench'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { faHandsHeart } from '@fortawesome/pro-solid-svg-icons/faHandsHeart'
import { faMicrophone } from '@fortawesome/pro-solid-svg-icons/faMicrophone'
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faStop } from '@fortawesome/pro-solid-svg-icons/faStop'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'

library.add(
  faArrowLeft,
  faCamera,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faCircle,
  faCloud,
  faCog,
  faColumns,
  faCopy,
  faEdit,
  faEllipsisV,
  faEnvelopeOpen,
  faFileImage,
  faFilePdf,
  faFlag,
  faFolders,
  faFrown,
  faGlobe,
  faHandsHeart,
  faHome,
  falFlag,
  falHandsHeart,
  faList,
  faLockAlt,
  faMicrophone,
  faMinus,
  faMinusCircle,
  faPause,
  faPhotoVideo,
  faPlay,
  faPlus,
  faPlusCircle,
  farLockAlt,
  farUsersClass,
  farWrench,
  faSchool,
  faSearch,
  faShareAlt,
  faShieldCheck,
  faStars,
  faStop,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faUsersClass,
  faWrench,
)

export default function () {}
